import { initializeApp } from 'firebase/app';
import { getToken, initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { resolveDinamicaDatabaseId, resolvePlatformDatabaseId } from '../config/databaseGuard';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
// App Check em monitoramento (ADR-003, item 10; D137), como no hub: só com a chave do site configurada (produção, no
// corte). Firestore e Auth recebem o token sozinhos; as chamadas à API do hub levam o cabeçalho (hubApi.ts).
const chaveAppCheck = (import.meta.env.VITE_APPCHECK_SITE_KEY as string | undefined)?.trim();
const appCheck = chaveAppCheck
  ? initializeAppCheck(app, { provider: new ReCaptchaEnterpriseProvider(chaveAppCheck), isTokenAutoRefreshEnabled: true })
  : null;

/** Cabeçalho do App Check para a API do hub (inclusive o /sso/me); sem App Check, vazio. */
export async function cabecalhoAppCheck(): Promise<Record<string, string>> {
  const token = await tokenAppCheck();
  return token ? { 'X-Firebase-AppCheck': token } : {};
}

/** Token do App Check para a API do hub; sem App Check, nada. */
export async function tokenAppCheck(): Promise<string | null> {
  if (!appCheck) return null;
  try {
    return (await getToken(appCheck, false)).token;
  } catch {
    return null;
  }
}
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
// Banco da Dinâmica por ambiente (D57): clone no servidor de desenvolvimento, produção no build.
const db = getFirestore(
  app,
  resolveDinamicaDatabaseId(import.meta.env.DEV, import.meta.env.VITE_DINAMICA_DATABASE_ID)
);
// Banco da plataforma: o perfil do professor (nome e letra salva, D84), no mesmo projeto e com o mesmo login.
const dbPlataforma = getFirestore(
  app,
  resolvePlatformDatabaseId(import.meta.env.DEV, import.meta.env.VITE_PLATFORM_DATABASE_ID)
);

// Ativar Modo Offline-First AAA para o Firestore
try {
  enableMultiTabIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Persistência requer apenas uma aba aberta.');
    } else if (err.code === 'unimplemented') {
      console.warn('Browser não suporta IndexedDB de persistência offline.');
    }
  });
} catch (error) {
  console.warn('Erro ao inicializar persistência local:', error);
}

export { auth, googleProvider, db, dbPlataforma };
